import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import { type SxProps, useTheme } from "@mui/material/styles";

import { getExpandToggleIconButtonSx } from "./get-expand-toggle-icon-button.sx";

type ExpandToggleIconButtonProps = {
  open?: boolean;
  onToggle: () => void;
  iconSx?: SxProps;
  "aria-label"?: string;
};

/** Shared expand/collapse control used by billing tables and other expandable rows. */
export default function ExpandToggleIconButton({
  open,
  onToggle,
  iconSx,
  "aria-label": ariaLabel
}: ExpandToggleIconButtonProps) {
  const theme = useTheme();
  const label = ariaLabel ?? (open ? "Collapse" : "Expand");

  return (
    <IconButton
      aria-label={label}
      aria-expanded={open}
      sx={getExpandToggleIconButtonSx(theme, { mr: 1.5, ...iconSx })}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {!open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
    </IconButton>
  );
}
